module.exports = __webpack_public_path__ + "static/media/Moet_Hennessy.7ca4c50b.svg";